/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateV2GetParamsRequest {
    getFixupPrototypeFunction() { return TemplateV2GetParamsRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateV2GetParamsRequest>): TemplateV2GetParamsRequest {
        let obj = Object.assign(new TemplateV2GetParamsRequest(), model);
        TemplateV2GetParamsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateV2GetParamsRequest>): TemplateV2GetParamsRequest {
        if (!model) return null;
        return TemplateV2GetParamsRequest.newInstance(<TemplateV2GetParamsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateV2GetParamsRequest) {
        if (!obj) return;

        models.TemplateV2GetParamsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateV2GetParamsRequest): boolean {
        Object.setPrototypeOf(obj, TemplateV2GetParamsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_accounts) {
            for (let val of this.service_accounts) {
                models.TemplateServiceAccount.fixupPrototype(val);
            }
        }
    }

    /**
     * Service accounts to resolve live parameter values against. Optional.
     */
    service_accounts: Array<models.TemplateServiceAccount>;

}
